<template>
  <div class="w-full text-left grid grid-nogutter">
    <div class="col-12">
      <div class="px-3 py-4">
        Completa los siguientes pasos para crear un nuevo territorio o editar
        uno existente.
      </div>
      <div class="flex gap-2 px-3  mb-4">
        <Button label="Guardar" data-e2e="btn-guardar-territorio" @click="guardar" />
        <Button label="Cancelar" data-e2e="btn-cancelar-territorio" severity="secondary" @click="cancel" />
      </div>
      <div class="pr-4">
        <Stepper
          orientation="vertical"
          @update:activeStep="setActiveStep"
          :activeStep="step"
        >
          <StepperPanel header="Asignar nombre y detalles">
            <template #content="{ nextCallback }">
              <div class="flex flex-column gap-2 py-4">
                <TarjetaTerritorio />
                <TarjetaHelp :step="0" />
              </div>
            </template>
          </StepperPanel>
          <StepperPanel header="Marcar limites en el mapa">
            <template #content>
              <div class="flex flex-column gap-2">
                

                <div
                  class="flex gap-2 align-items-baseline justify-content-between"
                >
                  <TarjetaHelp :step="1" show />
                </div>
                <Button label="Ver Mapa" outlined @click="openMap('Marcar limites')" />
              </div>
            </template>
          </StepperPanel>
          <StepperPanel
            header="Definir manzanas"
            v-if="terr.tipo === 'default'"
          >
            <template #content="{ prevCallback, nextCallback }">
              <div class="flex flex-column gap-2">
                

                <div
                  class="flex gap-2 align-items-baseline justify-content-between"
                >
                  <TarjetaHelp :step="2" show />
                </div>

                <Button label="Ver Mapa" outlined @click="openMap('Definir centro y manzanas')" />
              </div>
            </template>
          </StepperPanel>
          <StepperPanel header="Definir puntos de encuentro">
            <template #content="{ prevCallback, nextCallback }">
              <div class="flex flex-column gap-2">
                <!-- <div class="flex gap-2">
                  <Button
                    label="Quitar Ultimo"
                    outlined
                    @click="removeLastPE()"
                  />
                </div> -->

                <div
                  class="flex gap-2 align-items-baseline justify-content-between"
                >
                  <TarjetaHelp :step="3" show />
                </div>
                <Button label="Ver Mapa" outlined @click="openMap('Definir puntos de encuentro')" />
              </div>
            </template>
          </StepperPanel>
          <StepperPanel header="Características del territorio">
            <template #content>
              <div class="flex flex-column gap-4 py-4">

                <div class="flex flex-column gap-1">
                  <label class="text-sm font-medium">Tamaño de grupo</label>
                  <InputNumber v-model="terr.tamanoGrupo" :min="1" :max="200" placeholder="Número de personas" class="w-10rem" />
                </div>

                <div class="flex flex-column gap-1">
                  <label class="text-sm font-medium">Apto durante lluvia</label>
                  <SelectButton v-model="terr.aptoDuranteLluvia" :options="['Sí', 'No']" />
                </div>

                <div class="flex flex-column gap-1">
                  <label class="text-sm font-medium">Apto luego de lluvia</label>
                  <SelectButton v-model="terr.aptoLuegoDeLluvia" :options="['Sí', 'No']" />
                </div>

                <div class="flex flex-column gap-1">
                  <label class="text-sm font-medium">Tipo de vehículo</label>
                  <MultiSelect
                    v-model="terr.tipoVehiculo"
                    :options="tiposVehiculo"
                    placeholder="Seleccionar tipos..."
                    display="chip"
                  />
                </div>

                <div class="flex flex-column gap-1">
                  <label class="text-sm font-medium">Seguridad</label>
                  <SelectButton v-model="terr.seguridad" :options="nivelesAMB" />
                </div>

                <div class="flex flex-column gap-1">
                  <label class="text-sm font-medium">Nivel de productividad</label>
                  <SelectButton v-model="terr.nivelProductividad" :options="nivelesAMB" />
                </div>

                <div class="flex flex-column gap-1">
                  <label class="text-sm font-medium">Publicadores cerca</label>
                  <Textarea v-model="terr.publicadoresCerca" rows="2" autoResize placeholder="Nombres de publicadores cercanos..." />
                </div>

                <div class="flex flex-column gap-1">
                  <label class="text-sm font-medium">Observaciones</label>
                  <Textarea v-model="terr.observaciones" rows="3" autoResize placeholder="Notas adicionales..." />
                </div>

                <div class="flex flex-column gap-2">
                  <label class="text-sm font-medium">Datos adicionales</label>
                  <div class="flex gap-2 flex-wrap">
                    <Button
                      label="Estudios iniciados"
                      :badge="terr.estudios.length > 0 ? String(terr.estudios.length) : undefined"
                      outlined
                      icon="pi pi-book"
                      @click="route.$patch({ page: 'estudiosTerritorio', params: { id: terr.uuid } })"
                    />
                    <Button
                      label="Transporte"
                      :badge="terr.transporte.length > 0 ? String(terr.transporte.length) : undefined"
                      outlined
                      icon="pi pi-map-marker"
                      @click="route.$patch({ page: 'transporteTerritorio', params: { id: terr.uuid } })"
                    />
                  </div>
                </div>

              </div>
            </template>
          </StepperPanel>
          <StepperPanel
            header="Seleccionar Rutas (Opcional)"
            v-if="terr.tipo === 'routes'"
          >
            <template #content>
              <div class="flex flex-column gap-2 py-4">
                <RutasSelector v-model="terr.routes" />
                <TarjetaHelp :step="4" />
              </div>
            </template>
          </StepperPanel>
        </Stepper>
      </div>
      
    </div>
    <Sidebar v-model:visible="showMap" class="menumap"  position="full" >
      <template #header>
        <div class="flex align-items-center gap-2 justify-content-between w-full p-1">
            <div class="pl-1 text-lg">
              {{ titleModal }}
            </div>
            <div>
              <div class="flex gap-2">
                  <!-- <Button
                    icon="pi pi-undo" 
                    size="small"
                    severity="secondary"
                    @click="removeLast(step)"
                  /> -->
                  <Button
                    icon="pi pi-trash"
                    size="small"
                    severity="secondary"
                    class="mr-1"
                    @click="clear(step)"
                  />
                </div>
            </div>
        </div>
      </template>
      <div class="relative">
        <MapaBase
          class="map"
          ref="mapBase"
          :terrID="terr.zona + terr.numero"
          :center="terr.center"
          :color="terr.color"
          @mapClick="onMapClick"
          @mapMoveend="() => onMapMoveend()"
          @zoomstart="zoomstart"
          @zoomend="zoomend"
          @ready="ready"
          @dragendMz="dragEndMz"
          @clickMz="removeMz"
          v-if="showMapCount"
        ></MapaBase>

        <div class="absolute bottom-0 h-15rem w-full bg-white overflow-auto" style="z-index: 1000;" v-if="step == 3">
          <div class="flex flex-column-reverse p-2 gap-2 mb-3">
            <div
              v-for="(item, index) in terr.puntoEncuentro"
              :key="index"
            >
              <div class="w-full">
                <div class="flex gap-2 justify-content-between align-items-end">

                  <label class="text-xs">Punto de Encuentro {{ index + 1 }} </label>
                  <Button
                    icon="pi pi-trash"
                    size="small"
                    text
                    severity="secondary"
                    @click="removePE(index)"
                  />
                </div>
                <div class="flex flex-column gap-1 pt-1">
                  <InputText
                    placeholder="Dirección"
                    v-model="item.direccion"
                  />
                  <InputText
                    placeholder="Nombre descriptivo (opcional)"
                    v-model="item.name"
                    class="text-xs"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  </div>
</template>

<script setup>
import TarjetaHelp from "@/components/TarjetaTerritorio/TarjetaHelp.vue";
import RutasSelector from "@/page/rutas/RutasSelector.vue";
import { ref, onMounted, computed, reactive } from "vue";
import { useTerritorioStore } from "@/store/territorio";
// import { useMapStore } from "@/store/map";
import { useMzNumbers } from "@/store/map/mzNumber";
import { useRouterStore } from "@/store/router";
import { useSaveTerritorio } from "@/composables/commands/useSaveTerritorio";
import { useNominatim } from "@/composables/useNominatim";

const { reverseGeocode } = useNominatim();

const tiposVehiculo = ['A pie', 'Bicicleta', 'Auto', 'Moto', 'Moto cross', '4x4', 'Transporte público'];
const nivelesAMB = ['Alta', 'Media', 'Baja'];

const route = useRouterStore();
const terr = useTerritorioStore();
const { execute: saveTerritorio } = useSaveTerritorio();
const mapBase = ref(null);
const mzNumbers = useMzNumbers();
const step = ref(0);
const showMap = ref(false);
const showMapCount = ref(false);
const titleModal = ref("");

const limitMarkers = [];
const manzanasMarkers = [];

const openMap = (title) => {
  showMap.value = true;
  showMapCount.value = true;
  titleModal.value = title;
};

const clear = (step) => {
  if (step == 1) clearLimits();
  if (step == 2) clearMzNumbers();
  if (step == 3) clearPuntoEncuentro();
};




const clearPuntoEncuentro = () => {
  terr.$patch({ puntoEncuentro: [] });
  renderPuntoEncuentro();
};

const removePE = (index) => {
  terr.$patch({ puntoEncuentro: terr.puntoEncuentro.filter((p, i) => i !== index) });
  renderPuntoEncuentro();
};

onMounted(() => {
  // console.log("terr.center", terr.center)
  // if (!terr.center) terr.$patch({ center: m().getCenter() });
  if (terr.numero > 0) step.value = 0;
});

const map = () => mapBase.value.m.map.value;
const m = () => mapBase.value.m;
// reactive({
//   map: mapBase.value.m.map.value,
//   L: mapBase.value.m.L,
//   m: mapBase.value.m,
// });


var polTerr;

const setActiveStep = (v) => (step.value = v);
const clearLimits = () => {
  // terr.limits.value = []
  terr.$patch({ limits: [] });
  if (polTerr) map().removeLayer(polTerr);
  polTerr = [];
  if (limitMarkers.length > 0) {
    for (let i in limitMarkers) {
      map().removeLayer(limitMarkers[i]);
    }
  }
};

const clearMzNumbers = () => {
  terr.$patch({ mzNumbers: [] });
  mzNumbers.$patch({ mzNumbers: [] });
};
const removeLastMz = () => {
  terr.$patch({ mzNumbers: terr.mzNumbers.slice(0, -1) });
  mzNumbers.$patch({ mzNumbers: mzNumbers.mzNumbers.slice(0, -1) });
};

const onMapClick = (e) => {
  if (step.value == 1) configureLimit(e);
  if (terr.tipo === "default") {
    if (step.value == 2) configureMzNumber(e);
    if (step.value == 3) configurePuntoEncuentro(e);
  } else {
    if (step.value == 2) configurePuntoEncuentro(e);
  }
};

const guardar = async () => {
  await saveTerritorio();
  step.value = 0;
};

const cancel = () => {
  terr.clear();
  step.value = 0;
  route.$patch({ page: "listaTerritorio" });
};

let activeLimitIndex = null;

const configureLimit = async (data) => {
  console.log("configureLimit", data);

  if (polTerr) map().removeLayer(polTerr);

  if (data) {
    if (activeLimitIndex !== null) {
      const limits = [...terr.limits];
      // replace activeLimitIndex
      // limits[activeLimitIndex] = [data.latlng.lat, data.latlng.lng];

      // add after activeLimitIndex
      limits.splice(activeLimitIndex + 1, 0, [data.latlng.lat, data.latlng.lng]);
      terr.$patch({ limits });
      // configureLimit();
      // return;
      activeLimitIndex = activeLimitIndex + 1;
    } else {
      terr.addLimit([data.latlng.lat, data.latlng.lng]);
    }
  }

  if (limitMarkers.length > 0) {
    for (let i in limitMarkers) {
      // console.log("remove", limitMarkers[i]);
      const marker = limitMarkers[i];
      map().removeLayer(marker);
    }
  }
  const markerIcon = m().L.icon({
    iconUrl: `marker-icon.png`,
    iconAnchor: [12, 41],
    iconSize: [25, 41],
  });

  for (let i in terr.limits) {
    const marker = m().L.marker({
        lat: terr.limits[i][0],
        lng: terr.limits[i][1],
      }, {
        icon: markerIcon,
        draggable: true
      }).addTo(map())

    let index = i;

    marker.on("dragend", (e) => {
      // console.log("dragend", e.target.getLatLng());
      let latlng = e.target.getLatLng();
      const limits = [...terr.limits];
      limits[index] = [latlng.lat, latlng.lng];
      terr.$patch({ limits });
      configureLimit();
    });
    marker.on('click', function (e) {
        activeLimitIndex = terr.limits.findIndex((l) => l[0] === e.latlng.lat && l[1] === e.latlng.lng);
    });
    marker.on('dblclick', function (e) {
        // console.log("dblclick", e)
        // console.log("contextmenu", e)
        let latlng = e.latlng;
        const limits = [...terr.limits];
        let indexRemove = limits.findIndex((l) => l[0] === latlng.lat && l[1] === latlng.lng);
        // remove point
        limits.splice(indexRemove, 1);
        terr.$patch({ limits });
        configureLimit();
    })
    limitMarkers.push(marker);
  }

  if (terr.limits.length > 0)
    polTerr = m()
      .L.polyline([...terr.limits, terr.limits[0]], m().sectorOption)
      .addTo(map());
};

const dragEndMz = (data) => {
  const { e, i} = data;
  console.log("dragEndMz", e);
  const latlng = e.target.getLatLng();
  const list = [...terr.mzNumbers];
  list[Number(i)] = [latlng, i];
  terr.$patch({ mzNumbers: list });
  mzNumbers.setMzNumbers(list);
};

const removeMz = (data) => {
  console.log("removeMz", data);
  const { e, i} = data;
  // const latlng = e.latlng;
  let list = [...terr.mzNumbers];
  list.splice(Number(i), 1);
  terr.$patch({ mzNumbers: list });
  mzNumbers.setMzNumbers(list);
  
};

const configureMzNumber = (data) => {
  if (data) terr.addMzNumber([data.latlng, terr.mzNumbers.length]);
  console.log(terr.mzNumbers);
  mzNumbers.setMzNumbers(terr.mzNumbers);
};

const zoomstart = () => {
  if (polTerr) map().removeLayer(polTerr);
};
const zoomend = () => {
  configureLimit();
};
const onMapMoveend = (e) => {
  console.log("onMapMoveend", mapBase.value.m, m().getCenter());
  terr.$patch({ center: m().getCenter() });
};

const ready = () => {
  mzNumbers.setMzNumbers([]);
  // console.log("readyyyy", terr.mzNumbers)
  configureLimit();
  if (terr.mzNumbers) mzNumbers.setMzNumbers(terr.mzNumbers);
  renderPuntoEncuentro();
};

window.addEventListener("storage", function (e) {
  if (e.storageArea === sessionStorage && e.key == "center") {
    //  console.log('change', e.newValue);
    terr.$patch({ center: JSON.parse(e.newValue) });
  }
  // else, event is caused by an update to localStorage, ignore it
});

const configurePuntoEncuentro = async (data) => {
  // console.log("dconfigurePuntoEncuentro", data.latlng)

  let address = await getStreetName(data.latlng);
  const a = address?.address
  const direccion = (a?.house_number ? `${a.road} ${a.house_number}`.trim() : null)
    ?? address?.intersection
    ?? a?.road
    ?? address?.name
    ?? address?.display_name?.split(',')[0]
    ?? ''

  terr.addPuntoEncuentro({
    name: "",
    direccion,
    latlng: data.latlng,
  });

  renderPuntoEncuentro();
};

const puntosEncuentroMarkers = [];

function renderPuntoEncuentro() {
  for (let i in puntosEncuentroMarkers) {
    map().removeLayer(puntosEncuentroMarkers[i]);
  }
  let list = [];
  const icon = L.icon({
    iconUrl: `/pe.png`,
    iconSize: [32, 32],
    alt: "Punto de Encuentro",
  });
  for (let i in terr.puntoEncuentro) {
    const marker = L.marker(terr.puntoEncuentro[i].latlng, { 
      icon,
      draggable: true
     }).addTo(map());

    let index = i;

    marker.on('click', function (e) {
      // console.log("click", e)
      let latlng = e.latlng;
      let indexRemove = terr.puntoEncuentro.findIndex((l) => l.latlng.lat === latlng.lat && l.latlng.lng === latlng.lng);
      // remove point
      terr.puntoEncuentro.splice(indexRemove, 1);
      renderPuntoEncuentro();
    })

    marker.on('dragend', function (e) {
      let latlng = e.target.getLatLng();
      let puntoEncuentro = [...terr.puntoEncuentro];
      puntoEncuentro[index].latlng = latlng;
      terr.$patch({ puntoEncuentro });
      renderPuntoEncuentro();
    });

    puntosEncuentroMarkers.push(marker);
  }
}

async function getStreetName(latlng) {
  return reverseGeocode(latlng)
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.max-page {
  min-height: 90vh;
}
/* p {
  color: grey;
  font-size: 0.8em;
} */
.stepActive {
  background-color: var(--accent-soft);
}
</style>

<style>
.menumap.p-sidebar .p-sidebar-content {
  padding: 0 !important;
}

.menumap.p-sidebar .p-sidebar-header {
  padding: 5px 5px 5px !important;
  background: var(--accent);
  color: white;
  font-weight: normal;
}

</style>